<template>
  <div>
    <!-- 第一屏 -->
    <div
      class="InitialScreen"
      :style="'background: url('+InitialScreenCon.info.background_img+') no-repeat center;background-size: cover;height:'+height+''"
    >
      <div class="overview">
        <div
          class="title"
          @click="overviewClick()"
        >
          <span
            class="ellipsis"
            :title="InitialScreenCon.title"
          >{{InitialScreenCon.title}}</span>
          <p class="overImg el-icon-arrow-right">

          </p>
        </div>
        <div class="caption ellipsis4">
          {{InitialScreenCon.info.welcome_describe_cn}}
        </div>
        <el-button
          class="btn"
          @click="welcomeClick()"
        >{{InitialScreenCon.seeMore}}</el-button>
      </div>
      <div class="sb">
        <img
          class="sbImg"
          src="../../../static/image/shubiao.png"
          alt=""
          srcset=""
        >
        <span class="sp1"></span>
        <span class="span"></span>
      </div>
    </div>
    <!-- 头条新闻 -->
    <section class="section1">
      <div class="stitle">
        <p class="p">{{typeList[0].type_name_cn}}</p>
        <p class="p">{{typeList[0].type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <ul class="news SecNews" v-if="newsList.list.length>0">
        <li
          class="li"
          v-for="(item,i) of newsList.list"
          :key="i"
          @click="NewsDetail(item,33)"
        >
          <img
            class="newImg"
            :src="item.article_img"
            alt=""
          >
          <div
            class="ellipsis4 headline"
            :title="item.article_title_cn"
          >
            {{item.article_title_cn}}

          </div>
        </li>
      </ul>
      <el-button
        class="more"
        @click="moreNews(typeList[0].article_type_id,33)"
      >{{newsList.seeMore}}</el-button>
    </section>
    <!-- 学术校园 -->
    <section class="section2">
      <div class="stitle">
        <p class="p">{{typeList[1].type_name_cn}}</p>
        <p class="p">{{typeList[1].type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <div class="content" v-if="newsList2.list.length>0">
        <swiper
          ref="mySwiper"
          :options="swiperOption"
          class="myswiper"
        >
          <swiper-slide
            class="swiperslide"
            v-for="(item,i) of newsList2.list"
            :key='i'
          >
            <!-- @click="teacherDetail(item)" -->
            <div
              class="swiperDiv"
              @mouseenter="onEnter"
              @mouseleave="onLeave"
            >
              <!-- @click="NewsDetail(item,13)" -->
              <div class="slideleft">
                <img
                  class=""
                  :src="item.article_img"
                  alt=""
                >
              </div>
              <div class="slideright">
                <p
                  class="title ellipsis2"
                  :title="item.article_title_cn"
                >{{item.article_title_cn}}</p>
                <div class="rightGeneral ellipsis4">
                  {{item.article_describe_cn}}
                </div>
                <div class="seeDetail">
                  {{newsList2.viewDetails}} >
                </div>
              </div>

            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev"><img
            src="../../../static/image/left.png"
            alt=""
            srcset=""
          ></div>
        <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
        <div class="swiper-button-next"><img
            src="../../../static/image/right.png"
            alt=""
            srcset=""
          ></div>
        <!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
        <div
          class="swiper-pagination"
          slot="pagination"
        ></div>
        <el-button
          class="more"
          @click="moreNews(typeList[1].article_type_id,13)"
        >{{newsList2.seeMore}}</el-button>
      </div>

    </section>
    <!-- 活力校园 -->
    <section
      class="section3"
      :style="'background: url('+typeList[2].background_img+') no-repeat center;background-size: cover;'"
    >
      <!--typeList[2].background_img -->
      <div class="stitle">
        <p class="p">{{typeList[2].type_name_cn}}</p>
        <p class="p">{{typeList[2].type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi2.png"
          alt=""
        >
      </div>
      <div class="content" v-if="newsList3.list.length>0">
        <ul class="vigorous">
          <li class="li">
            <div
              class="left active"
              @click="NewsDetail(newsList3.list[0],12)"
            >
              <img
                class="img"
                :src="newsList3.list[0].article_img"
                alt=""
              >
              <p
                class="title ellipsis2"
                :title="newsList3.list[0].article_title_cn"
              >{{newsList3.list[0].article_title_cn}}</p>
            </div>
          </li>
          <li class="li">
            <div
              class="right active"
              v-for="(item,i) of newsList3.list.slice(1)"
              :key="i"
              @click="NewsDetail(item,12)"
            >
              <img
                class="img"
                :src="item.article_img"
                alt=""
              >
              <p
                class="title ellipsis2"
                :title="item.article_title_cn"
              >{{item.article_title_cn}}</p>
            </div>
            <div
              class="right active more"
              @click="VibrantCampus(typeList[2].article_type_id)"
            >
              <img
                class="img"
                :src="newsList3.background_img"
                alt=""
              >
              <p class="title">{{newsList3.seeMore}}</p>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <!-- 温馨校园 -->
    <section class="section4">
      <div class="stitle">
        <p class="p">{{warmCon.schoolTitle_cn}}</p>
        <p class="p">{{warmCon.schoolTitle_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <div class="content" >
        <div
          class="leftTitle"
          ref="warmheight"
        >
          <div
            :class="warmNum==i?'text active4':'text'"
            @click="warmClick(i)"
            v-for="(item,i) of warmCon.list"
            :key="i"
          >
            <p class="p1">{{item.campus_title_cn}}</p>

            <p>{{item.campus_sketch_cn}}</p>
          </div>
        </div>
        <div
          class="rightCon"
          :style="'height:'+warmHeight"
        >
          <img
            class="img"
            :src="warmCon.list[warmNum].background_img"
            alt=""
            v-if="warmCon.list[warmNum]"
          >
          <div
            :class="warmNum==i?'contentPanel':'contentPanel animation'"
            v-for="(item,i) of warmCon.list"
            :key="i"
          >
            <p class="ellipsis4">
              {{item.campus_describe_cn}}
            </p>
            <el-button
              class="more"
              @click="warmRoute(i)"
            >{{warmCon.seeMore}}</el-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import {
  overviewInfo,
  CampusGetLists,
  Article_type,
  ArticlegetList
} from "@/api/Overview";
export default {
  name: "PrimarySchool",
  data() {
    let _that = this;
    return {
      height: "", //高度
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        effect: "cube",
        // slidesPerView: 2,
        // centeredSlides:true,
        cubeEffect: {
          shadow: false
          // shadowOffset:100,
          // shadowScale: 0.6,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        // setWrapperSize: true,
        preventClicksPropagation: true,
        loop: true,
        observer: true,
        observeParents: true,
        on: {
          click: function() {
            var laber = [0, 2, 13, 18];
            var laPath = ["/", "/PrimarySchool", "/PrimarySchool"];
            // item.article_id
            var routeData = _that.$router.resolve({
              path: "/NewsDetails",
              query: {
                laber: JSON.stringify(laber),
                id: _that.newsList2.list[this.realIndex].article_id,
                laPath: JSON.stringify(laPath)
              }
            });
            window.open(routeData.href, "_blank");
          }
        }
      }, //swiper参数
      warmList: [
        {
          title: "生活篇",
          nodule: "贴心的服务",
          path: "/FineService"
        },
        {
          title: "共育篇",
          nodule: "加强学校与家长之间的联系",
          path: "/CoCultivation"
        },
        {
          title: "环境篇",
          nodule: "舒适的学习环境",
          path: "/GalleryDetail"
        }
      ], //温馨校园path
      warmNum: 0,
      warmHeight: 559,
      InitialScreenCon: { info: {} }, //概览
      warmCon: { list: [{ background_img: "" }] }, //温馨校园
      typeList: [{}, {}, {}], //文章分类
      newsList: { list: [{}], background_img: "" }, //头条新闻
      newsList2: { list: [{}], background_img: "" }, //学术校园
      newsList3: { list: [{}], background_img: "" } //活力校园
    };
  },
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  computed: {
    ...mapState("user", ["headerHeight"]),
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  methods: {
    // 监听浏览器高度宽度变化
    getHeight() {
      //   console.log(this.headerHeight, "dfsf");
      this.height = window.innerHeight - this.headerHeight + "px";
      setTimeout(() => {
        this.warmHeight = this.$refs.warmheight.offsetHeight + "px";
      }, 500);
    },
    // 学术校园
    // swiperClick(i) {
    //   console.log(i);
    // },
    // 鼠标移入暂停循环轮播
    onEnter() {
      if (this.swiper.autoplay) {
        this.swiper.autoplay.stop();
      }
    },
    onLeave() {
      if (this.swiper.autoplay) {
        this.swiper.autoplay.start();
      }
    },
    // 温馨校园
    warmClick(item) {
      this.warmNum = item;
    },
    // 园所概览
    overviewClick() {
      var laber = [0, 2, 19];
      var laPath = ["/", "/PrimarySchool"];
      this.$router.push({
        path: "/Overview",
        query: {
          sid: 2,
          laber: JSON.stringify(laber),
          laPath: JSON.stringify(laPath)
        }
      });
    },
    // 学校欢迎词
    welcomeClick() {
      this.$router.push({ path: "/Welcome", query: { sid: 2 } });
    },
    // 温馨校园跳转
    warmRoute(i) {
      var laber = [0, 2, 35];
      var laPath = ["/", "/PrimarySchool", "/PrimarySchool"];
      if (i == 2) {
        laber.push(18);
      }
      if (i == 1) {
        laber.push(23);
      }
      if (i == 0) {
        laber.push(24);
      }
      this.$router.push({
        path: this.warmList[i].path,
        query: {
          laber: JSON.stringify(laber),
          laPath: JSON.stringify(laPath),
          id: this.warmCon.album_id,
          uid: 2
        }
      });
    },
    // 活力校园列表VibrantCampusList
    VibrantCampus(index) {
      var laber = [0, 2, 12, 17];
      var laPath = ["/", "/PrimarySchool", "/PrimarySchool"];
      this.$router.push({
        path: "/VibrantCampusList",
        query: {
          laber: JSON.stringify(laber),
          laPath: JSON.stringify(laPath),
          uid: index
        }
      });
    },
    // 教师/团队详情
    teacherDetail(i) {
      var laber = ["小学", "优秀团队详情"];
      this.$router.push({
        path: "/TeacherDetail",
        query: { laber: JSON.stringify(laber) }
      });
    },
    // 跳转新闻列表
    moreNews(index, x) {
      var laber = [0, 2, x, 22];
      var laPath = ["/", "/PrimarySchool", "/PrimarySchool"];
      this.$router.push({
        path: "/NewsList",
        query: {
          laber: JSON.stringify(laber),
          laPath: JSON.stringify(laPath),
          uid: index
        }
      });
    },
    // 新闻详情
    NewsDetail(item, x) {
      var laber = [0, 2, x, 18];
      var laPath = ["/", "/PrimarySchool", "/PrimarySchool"];
      // item.article_id
      var routeData = this.$router.resolve({
        path: "/NewsDetails",
        query: {
          laber: JSON.stringify(laber),
          id: item.article_id,
          laPath: JSON.stringify(laPath)
        }
      });
      window.open(routeData.href, "_blank");
    },
    // 新闻列表
    ArticlegetLists(i, page) {
      ArticlegetList({
        article_type_id: this.typeList[i].article_type_id,
        limit: page
      }).then(res => {
        if (i == 0) {
          this.newsList = res.data;
        } else if (i == 1) {
          // console.log(res.data);
          this.newsList2 = res.data;
        } else if (i == 2) {
          this.newsList3 = res.data;
        }
      });
    }
  },
  created() {},
  mounted() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    overviewInfo({
      overview_park: 2
    }).then(res => {
      // console.log(res.data);
      this.InitialScreenCon = res.data;
    });
    // 温馨校园
    CampusGetLists({
      park: 2
    }).then(res => {
      // console.log(res.data);
      this.warmCon = res.data;
    });
    // 文章分类 2
    Article_type({ park: 2 }).then(res => {
      // console.log(res.data);
      this.typeList = res.data;
      this.ArticlegetLists(0, 6);
      this.ArticlegetLists(1, 5);
      this.ArticlegetLists(2, 4);
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.InitialScreen {
  position: relative;
  width: 100%;
  //   height: 79.5vh;
  background-size: cover;
  padding-top: 0.1px;
  &::before {
    display: block;
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 0;
    top: 0;
    left: 0;
  }
  .overview {
    position: relative;
    margin-left: 16.1%;
    margin-top: 5%;
    z-index: 1;
    text-align: left;
    .title {
      position: relative;
      font-size: px2Rem(80px);
      // font-family: "STXinwei";
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
      span {
        vertical-align: middle;
      }
      &::before {
        display: block;
        position: absolute;
        content: "";
        width: px2Rem(100px);
        height: px2Rem(4px);
        bottom: px2Rem(-30px);
        left: px2Rem(10px);
        border-radius: 2px;
        background-color: #fff;
      }
      &:hover {
        .overImg {
          background: rgba(255, 255, 255, 0.3);
        }
      }
    }

    .caption {
      width: px2Rem(707px);
      height: px2Rem(175px);
      margin-top: px2Rem(70px);
      font-size: px2Rem(28px);
      // font-family: STXinwei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: px2Rem(36px);
      -webkit-line-clamp: 5;
      line-clamp: 5;
    }
    .btn {
      padding: px2Rem(19px) px2Rem(68px);
      margin-top: px2Rem(60px);
      border: 2px solid rgba(255, 255, 255, 1);
      border-radius: 4px;
      font-size: px2Rem(24px);
      // font-family: STXinwei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      background: rgba(0, 0, 0, 0);
      transition: 0.3s;
      &:hover {
        background: rgba(255, 255, 255, 0.8);
        color: rgba(28, 50, 120, 1);
        border: 2px solid rgba(28, 50, 120, 0.1);
      }
    }
  }
}

.section1 {
  width: px2Rem(1300px);
  margin: px2Rem(60px) auto;

  .more {
    display: block;
    margin: px2Rem(10px) auto 0px;
    padding: px2Rem(20px) px2Rem(68);
    border: 1px solid rgba(28, 50, 120, 1);
    border-radius: 4px;
    font-size: px2Rem(24px);
    // font-family: STXinwei;
    font-weight: 400;
    color: rgba(28, 50, 120, 1);
    transition: 0.3s;
    &:hover {
      background: rgba(28, 50, 120, 0.5);
      color: #fff;
      border: 1px solid #fff;
    }
  }
}
.section2 {
  padding-top: px2Rem(80px);
  background: #f5f5f5;
  .content {
    position: relative;
    width: px2Rem(1300px);
    // height: px2Rem(500px);
    padding-bottom: px2Rem(40px);
    margin: px2Rem(35px) auto px2Rem(0px);
    --swiper-theme-color: #e2bb81;

    .myswiper {
      // padding: 0 px2Rem(60px);
      // height: px2Rem(400px);
      outline: none;
      .swiperslide {
        width: 100% !important;
        margin: 0 2px;
      }
      .swiperDiv {
        width: px2Rem(1120px);
        margin: auto;
        // text-align: center;
        cursor: pointer;
        &:hover {
          .slideright {
            .title {
              color: rgba(28, 50, 120, 1);
            }
            .seeDetail {
              color: rgba(28, 50, 120, 1);
            }
          }
        }
      }
    }
    .swiper-pagination {
      // margin: auto;
      width: 100%;
      padding-top: px2Rem(20px);
      // outline: none;
      /deep/ .swiper-pagination-bullet {
        margin-right: px2Rem(25px);
        outline: none;
      }
    }
    .swiper-button-next,
    .swiper-button-prev {
      width: px2Rem(54px);
      height: px2Rem(54px);
      top: 35%;
      // left: ;
      outline: none;
      border-radius: 51%;
      transition: 0.5s;
      &::after {
        display: none;
      }
      &:hover {
        background: rgba(28, 50, 120, 0.1);
      }
      img {
        width: px2Rem(54px);
        height: px2Rem(54px);
      }
    }
    .slideleft {
      display: inline-block;
      width: px2Rem(650px);
      height: px2Rem(400px);
      margin-right: px2Rem(20px);
      vertical-align: top;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .slideright {
      display: inline-block;
      width: px2Rem(420px);
      text-align: left;
      .title {
        font-size: px2Rem(34px);
        // font-family: STXinwei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .rightGeneral {
        margin-top: px2Rem(40px);
        font-size: px2Rem(28px);
        // font-family: STXinwei;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        -webkit-line-clamp: 5;
        line-clamp: 5;
      }
    }
    .more {
      display: block;
      margin: px2Rem(70px) auto px2Rem(0px);
      padding: px2Rem(19px) px2Rem(68px);
      // margin-top: px2Rem(70px);
      border: 1px solid #1c3278;
      border-radius: 4px;
      font-size: px2Rem(24px);
      // font-family: STXinwei;
      font-weight: 400;
      color: #1c3278;
      background: rgba(0, 0, 0, 0);
      transition: 0.3s;
      transition: 0.3s;
      &:hover {
        background: rgba(28, 50, 120, 0.5);
        color: #fff;
        border: 1px solid #fff;
      }
    }
  }
  .seeDetail {
    margin-top: px2Rem(115px);
    color: #999;
  }
}
.section3 {
  // height: px2Rem(600px);
  position: relative;
  padding-top: px2Rem(60px);
  padding-bottom: px2Rem(50px);
  &::before {
    display: block;
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 0;
    top: 0;
    left: 0;
  }
  .content {
    width: px2Rem(1300px);
    margin: px2Rem(35px) auto px2Rem(0px);
    .vigorous {
      font-size: 0;
      .li {
        display: inline-block;
        position: relative;
        vertical-align: top;
        &:nth-of-type(1) {
          width: px2Rem(640px);
          margin-right: px2Rem(10px);
          // height: px2Rem(220px);
        }
        &:nth-of-type(2) {
          width: px2Rem(650px);
          // height: px2Rem(220px);
        }
        .left {
          height: px2Rem(430px);
        }
        .right {
          display: inline-block;
          width: px2Rem(320px);
          height: px2Rem(210px);
          margin-right: px2Rem(10px);
          &:nth-of-type(2n) {
            margin-right: 0;
          }
        }
        .active {
          // width: 100%;
          margin-bottom: px2Rem(10px);
          position: relative;
          overflow: hidden;
          cursor: pointer;
          &::before {
            display: block;
            content: "";
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            height: 100%;
            background: #333;

            z-index: 1;
            transition: 0.3s;
            opacity: 0;
          }
          .img {
            width: 100%;
            height: 100%;
            transition: 0.3s;
            z-index: 0;
          }
          .title {
            position: absolute;
            // width: 100%;
            top: 50%;
            left: 0;
            right: 0;
            margin: auto;
            padding: 0 px2Rem(10px);
            text-align: center;
            font-size: px2Rem(28px);
            // font-family: STXinwei;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            transform: translate(0, -50%);
            transition: 0.3s;
            opacity: 0;
          }
          &:hover {
            .title {
              opacity: 1;
            }
            .img {
              transform: scale(1.1);
            }
            &::before {
              opacity: 0.4;
            }
          }
        }
        .more {
          .title {
            opacity: 1;
          }
          &::before {
            opacity: 0.4;
          }
        }
      }
    }
  }
  .stitle {
    position: relative;
    p {
      color: rgba(255, 255, 255, 1);
      &:nth-of-type(2) {
        color: rgba(255, 255, 255, 1);
      }
    }
  }
}
.section4 {
  padding-top: px2Rem(60px);
  padding-bottom: px2Rem(60px);
  background: #f5f5f5;
  .content {
    width: px2Rem(1300px);
    // height: 100%;
    // border: 1px #f5f5f5 solid;
    margin: px2Rem(35px) auto 0;
    font-size: 0;
    //
    .leftTitle {
      display: inline-block;
      width: px2Rem(500px);
      .text {
        padding: px2Rem(27px) px2Rem(10px) px2Rem(42px) px2Rem(30px);
        // height: px2Rem(110px);
        background: rgba(28, 50, 120, 1);
        transition: 0.3s;
        cursor: pointer;
        &:hover {
          background: rgba(226, 187, 129, 1);
          p {
            color: rgba(51, 51, 51, 1);
          }
          .p1::after {
            background: rgba(51, 51, 51, 1);
          }
        }
        &:nth-of-type(2) {
          border-top: 2px #fff solid;
          border-bottom: 2px #fff solid;
        }
        p {
          position: relative;
          font-size: px2Rem(34px);
          // font-family: STXinwei;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          &:nth-of-type(2) {
            margin-top: px2Rem(50px);
            font-size: px2Rem(28px);
            font-weight: 400;
          }
        }
        .p1::after {
          position: absolute;
          display: block;
          content: "";
          width: px2Rem(58px);
          height: px2Rem(4px);
          min-height: 2px;
          bottom: px2Rem(-15px);
          left: px2Rem(5px);
          background: rgba(255, 255, 255, 1);
          border-radius: 2px;
        }
      }
      .active4 {
        background: rgba(226, 187, 129, 1);
        p {
          color: rgba(51, 51, 51, 1);
        }
        .p1::after {
          background: rgba(51, 51, 51, 1);
        }
      }
    }
    .rightCon {
      display: inline-block;
      position: relative;
      width: px2Rem(800px);
      // height: px2Rem(540px);
      vertical-align: top;
      overflow: hidden;

      .img {
        position: absolute;
        width: 100%;
        height: 100%;
      }
      .contentPanel {
        position: absolute;
        width: px2Rem(680px);
        top: 50%;
        left: 0;
        right: 0;
        margin: auto;
        padding: 0 px2Rem(60px);
        font-size: px2Rem(28px);
        // font-family: STXinwei;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        transform: translate(0, -50%);
        transition: 1s;
        p {
          line-height: px2Rem(40px);
        }
        .more {
          display: block;
          margin-top: px2Rem(50px);
          padding: px2Rem(20px) px2Rem(66px);
          border: 2px solid rgba(255, 255, 255, 1);
          border-radius: 4px;
          background: rgba(0, 0, 0, 0);
          font-size: px2Rem(24px);
          // font-family: STXinwei;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          transition: 0.3s;
          &:hover {
            background: rgba(255, 255, 255, 0.8);
            color: rgba(28, 50, 120, 1);
            border: 2px solid rgba(28, 50, 120, 0.1);
          }
        }
      }
      .animation {
        left: 150%;
        opacity: 0;
        visibility: hidden;
        transition: 0s;
      }
    }
  }
}
.stitle {
  text-align: center;
  .p {
    font-size: px2Rem(50px);
    // font-family: STXinwei;
    font-weight: bold;
    color: rgba(28, 50, 120, 1);
    &:nth-of-type(2) {
      padding: px2Rem(15px) 0 px2Rem(29px);
      font-size: px2Rem(24px);
      font-family: Arial;
      font-weight: 400;
      color: rgba(205, 205, 205, 1);
    }
  }
  > img {
    width: px2Rem(28);
    height: px2Rem(28);
  }
}
.title {
  z-index: 1;
}
</style>


// WEBPACK FOOTER //
// src/views/PrimarySchool/Index.vue